<template>
  <!-- eslint-disable -->
  <div :class="$style['cookie-page']" v-once>
    <title>Согласие на обработку персональных данных</title>
    <app-layout :render-left-column="false">
      <template slot="central-column">
        <div :class="$style['container']">
          <jtn-ui-side-block-header :class="$style['header']" :text="'Информация'" />

          <jtn-ui-typography
            :class="$style['static-page-content']"
            :tag="'div'"
            :type="'font-second-news-txt'"
            :link-type="'link-blue'"
          >
            <jtn-ui-typography :type="'font-center-title'">
              Согласие на обработку персональных данных
            </jtn-ui-typography>

            <p>
              Я, являясь пользователем сайта/сайтов 29.ru, ngs22.ru, vladivostok1.ru,
              v1.ru, voronezh1.ru, e1.ru, izh1.ru, ircity.ru, 116.ru, 93.ru, ngs24.ru,
              ngs42.ru, 45.ru, mgorsk.ru, msk1.ru, 51.ru, nn.ru, ngs.ru, ngs55.ru, 56.ru,
              59.ru, 161.ru, 63.ru, 164.ru, sochi1.ru, 26.ru, tolyatty.ru, ngs70.ru,
              71.ru, 72.ru, 173.ru, ufa1.ru, 86.ru, 74.ru, chita.ru, 14.ru, 76.ru, 53.ru,
              35.ru, 43.ru, 48.ru, 89.ru, sterlitamak1.ru, 68.ru в порядке статьи 9
              Федерального закона от 27.07.2006 N 152-ФЗ «О персональных данных» даю ООО
              «Интернет технологии», администратору сайтов, (<b
                >ООО «Интернет Технологии»</b
              >
              (ИНН 7448104809 ОГРН 1087448005050), зарегистрировано по адресу: 630099,
              Новосибирская обл, г. Новосибирск, ул. Депутатская, д. 46, этаж 5 офис 3053,
              далее - оператор) конкретное, предметное, информированное, сознательное и
              однозначное согласие на обработку персональных данных.
            </p>
            <p>
              Оператор вправе производить как автоматизированную, так и
              неавтоматизированную обработку персональных данных с передачей по внутренней
              сети Оператора и с передачей по сети Интернет.
            </p>
            <p>
              Оператор вправе обрабатывать персональные данные в указанном ниже объеме и
              целях в зависимости от раздела сайта, пользователем которого я являюсь.
            </p>
            <p>
              Сообщая новость через форму обратной связи, равно как и по контактным данным
              редакции СМИ, учредителем которого является Оператор, персональные данные,
              содержащиеся в таком сообщении, обрабатываются в целях осуществления
              профессиональной деятельности журналиста и (или) законной деятельности
              средства массовой информации либо научной, литературной или иной творческой
              деятельности при условии, что при этом не нарушаются права и законные
              интересы субъекта персональных данных. С целью обратной связи с со мной при
              отправке сообщения даю согласие на обработку номера телефона и/или адреса
              электронной почты.
            </p>
            <p>
              Для этой цели Оператор вправе обрабатывать следующие виды персональных
              данных: фамилия, имя, отчество; год рождения; месяц рождения; дата рождения;
              место рождения; семейное положение; социальное положение; имущественное
              положение; доходы; пол; адрес электронной почты; адрес места жительства;
              адрес регистрации; номер телефона; СНИЛС; ИНН; гражданство; данные
              документа, удостоверяющего личность; данные документа, содержащиеся в
              свидетельстве о рождении; профессия; должность; сведения о трудовой
              деятельности (в том числе стаж работы, данные о трудовой занятости на
              текущее время с указанием наименования и расчетного счета организации);
              отношение к воинской обязанности, сведения о воинском учете; сведения,
              собираемые посредством метрических программ; фото-видео изображение лица и
              прочие персональные данные, сообщаемые пользователем. Оператор также вправе
              обрабатывать персональные данные, относящиеся к специальной категории
              персональных данных: сведения о состоянии здоровья; национальная
              принадлежность; политические взгляды; религиозные или философские убеждения;
              сведения о судимости.
            </p>
            <p>
              Я подтверждаю, что указанный перечень персональных данных может быть у
              Оператора только от меня.
            </p>
            <p>
              При подписке на новостную рассылку (опция «Подписка на новости» или
              «Подписка на рассылку») я даю согласие на обработку персональных данных, а
              именно адреса электронной почты, с целью получения новостной рассылки от
              Оператора по указанному мню адресу.
            </p>
            <p>
              При использовании разделов «Знакомства», «Форум», «Общение», «Туризм»,
              «Объявления», я даю согласие на обработку персональных данных с целью
              создания профиля, содержащего указанную мною информацию, будь то фамилия,
              имя, отчество, дата рождения, пол, адрес электронной почты, номер телефона и
              иные данные, позволяющие идентифицировать пользователя.
            </p>
            <p>
              Мне разъяснено, что регистрация пользователя осуществляется через Единый
              сервер авторизации. С целью регистрации, авторизации пользователя, я даю
              Оператору согласие на обработку следующих персональных данных: адрес
              электронной почты, номер телефона.
            </p>
            <p>
              С целью авторизации пользователя на любом разделе сайта или приложения
              Оператора разрешаю использовать данные, импортируемые из учетных записей
              социальных сетей «Вконтакте», «Одноклассники», «Мой мир», а также сервиса
              «Яндекс».
            </p>
            <p>
              Я разрешаю оператору собирать, записывать, систематизировать, накапливать,
              хранить, уточнять, (обновлять, изменять); использовать; передавать
              (предоставлять доступ), удалять, уничтожать персональные данные. При этом
              для целей использования некоторыми сервисами Оператора (например, сервисом
              «Знакомства» или «Общение») я даю Оператору согласие на распространение
              персональных данных.
            </p>
            <p>
              Я согласен с условием, что персональные данные обрабатываются и хранятся в
              срок до достижения целей обработки персональных данных или отзыва согласия
              на обработку персональных данных.
            </p>
            <p>
              С политикой конфиденциальности, расположенной по
              <a :href="personalDataLink" target="_blank">ссылке</a>, а также
              <a :href="cookiesLink" target="_blank"
                >политикой обработки персональных данных, содержащихся в куки-файлах</a
              >, ознакомлен и согласен с условиями.
            </p>
          </jtn-ui-typography>
        </div>
      </template>

      <template slot="right-column">
        <app-right-column />
      </template>
    </app-layout>
  </div>
  <!-- eslint-disable -->
</template>

<script>
import { JtnUiTypography, JtnUiSideBlockHeader } from '@jtnews/jtn-ui';

import { PageAnalyticsMixin } from '../shared/mixins/page-analytics';
import { WindowScrollMixin } from '../shared/mixins/window-scroll.mixin';

import AppLayout from '../layout/containers/app-layout';
import AppRightColumn from '../layout/containers/app-right-column';

export default {
  name: 'CookiePolicyPage',
  components: {
    JtnUiSideBlockHeader,
    JtnUiTypography,
    AppLayout,
    AppRightColumn
  },
  mixins: [WindowScrollMixin, PageAnalyticsMixin],
  data() {
    return {
      host: ''
    };
  },
  beforeMount() {
    if (guardUnspecified(window)) {
      this.host = window.location.host;
    }
  },
  computed: {
    cookiesLink() {
      return `${this.host}/cookie-policy/`;
    },
    personalDataLink() {
      return `${this.host}/usloviya-ispolzovaniya-veb-portala-i-politiku-konfidencialnosti-personalnyh-dannyh/`;
    }
  }
};
</script>

<style lang="scss" module>
@import 'styles';
@import '../styles/rules-page';

.cookie-page {
  display: block;
}
</style>
